import { Route } from 'react-router-dom';
import DashboardPage from '../../pages/raptor/dashboard/dashboard.page';

export const RaptorDashboardRoutes = (
  <Route path="/dashboard">
    <Route index element={<DashboardPage />} />
  </Route>
);
